import { Directive, ElementRef, computed, effect, input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { of } from 'rxjs';

import { LocaleService } from '../../core/services/locale/locale.service';
import { RendererService } from '../services/renderer/renderer.service';

@Directive({
    // eslint-disable-next-line
    selector: '[i18n]',
    standalone: true,
})
export class LocaleDirective {
    i18n = input.required<string>();
    i18nArgs = input<any>();

    private localeModuleLoaded = toSignal(
        this.localeService.isTranslationModuleLoaded.value ? of(true) : this.localeService.isTranslationModuleLoaded,
    );

    private localeString = computed(() => {
        if (this.localeModuleLoaded()) {
            return this.localeService.getString(this.i18n(), this.i18nArgs());
        }
        return '';
    });

    constructor(
        private rendererService: RendererService,
        public element: ElementRef,
        private localeService: LocaleService,
    ) {
        effect(() => {
            if (this.localeString()) {
                this.rendererService.renderer.setProperty(this.element.nativeElement, 'innerHTML', this.localeString());
            }
        });
    }
}
